import { render, staticRenderFns } from "./DenominationList.vue?vue&type=template&id=72297e18&scoped=true&"
import script from "./DenominationList.vue?vue&type=script&lang=ts&"
export * from "./DenominationList.vue?vue&type=script&lang=ts&"
import style0 from "./DenominationList.vue?vue&type=style&index=0&id=72297e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72297e18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
